export var ItemSelector = function (args) {
    var me = this;

    args = args || {};

    me.whenParentItemChanged = args.whenParentItemChanged;
    me.whenSelectedItemChanged = args.whenSelectedItemChanged;
    me.childSelectors = args.childSelectors || [];
    me.setParentItem(args.parentItem);
    me.setSelectedItem(args.selectedItem);
};

ItemSelector.prototype = {
    setParentItem: function (parentItem, force) {
        var me = this,
            oldParentId = me.parentItem && me.parentItem.Id,
            newParentId = parentItem && parentItem.Id;

        me.parentItem = parentItem;

        if ((oldParentId != newParentId) || force) {
            me.whenParentItemChanged && me.whenParentItemChanged(parentItem);
        }

        if (!parentItem) {
            me.setSelectedItem(null);
        }
    },
    setSelectedItem: function (selectedItem, force) {
        var me = this,
            oldSelectedId = me.selectedItem && me.selectedItem.Id,
            newSelectedId = selectedItem && selectedItem.Id;

        me.selectedItem = selectedItem;

        if ((oldSelectedId != newSelectedId) || force) {
            me.whenSelectedItemChanged && me.whenSelectedItemChanged(selectedItem);
        }

        me.setChildSelectorParentItems(force);
    },
    addChildSelector: function (childSelector) {
        var me = this;

        me.childSelectors.push(childSelector);
    },
    setChildSelectorParentItems: function (force) {
        var me = this;

        $.each(me.childSelectors, function (index, childSelector) {
            childSelector.setParentItem(me.selectedItem, force);
        });
    }
};
